@if (visible) {
  @if (variant === "icon") {
    <button
      type="button"
      class="btn btn-sm btn-success btn-icon rounded-circle flex-shrink-0"
      [disabled]="softphone.inProgress$ | async"
      [title]="
        (softphone.inProgress$ | async)
          ? ('softphone.widget.callInProgress' | translate)
          : ('softphone.widget.callTo' | translate: { name: contactName })
      "
      [attr.aria-label]="
        'softphone.widget.callTo' | translate: { name: contactName }
      "
      (click)="call()"
    >
      <i class="ri-phone-line fs-6"></i>
    </button>
  } @else {
    <!--
      `w-100`: the host is `display: block`, so both places that use this variant — the
      attendance panel's contact sidebar and the deal detail — put it in a narrow column
      where a pill at its natural width sits stranded next to a full-width sibling.
    -->
    <button
      type="button"
      class="btn btn-success btn-sm rounded-pill w-100 d-inline-flex align-items-center justify-content-center gap-1"
      [disabled]="softphone.inProgress$ | async"
      [title]="
        (softphone.inProgress$ | async)
          ? ('softphone.widget.callInProgress' | translate)
          : ('softphone.widget.callTo' | translate: { name: contactName })
      "
      (click)="call()"
    >
      <!-- `gap-1` on the button now spaces these, so the icon drops its own margin. -->
      <i class="ri-phone-line"></i>
      {{ 'softphone.widget.call' | translate }}
    </button>
  }
}
